/**
 * ContractsPage - the Contract Lifecycle (CLM) dashboard at /contracts.
 *
 * Every document flagged as a contract, tracked in one place: lifecycle status,
 * upcoming renewals, source alignment (document intelligence), and review risk —
 * with quick actions and a "needs attention" lens.
 */
import { useContext, useEffect } from 'react';
import CLMDashboard from '../components/Contracts/CLMDashboard';
import { LayoutContext } from '../contexts/LayoutContext';

function ContractsPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);
  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <CLMDashboard />;
}

export default ContractsPage;
